"use client";

import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  number: "01",
  title: "THEATRICAL PRODUCTIONS",
  description: "Leading roles in classical and contemporary stage works, from Shakespearean tragedies to avant-garde off-Broadway premieres.",
  tier: "STAGE"
}, {
  number: "02",
  title: "FEATURE FILM & INDIE",
  description: "Principal performances in cinematic narratives, specializing in complex character studies and high-stakes dramatic arcs.",
  tier: "SCREEN"
}, {
  number: "03",
  title: "TELEVISION & STREAMING",
  description: "Series regular and guest star appearances across major networks and global streaming platforms with a focus on gritty realism.",
  tier: "EPISODIC"
}, {
  number: "04",
  title: "VOICE & NARRATION",
  description: "Distinctive vocal performance for high-end commercial campaigns, documentary narration, and immersive audio dramas.",
  tier: "STUDIO"
}, {
  number: "05",
  title: "MOVEMENT & CHOREOGRAPHY",
  description: "Specialized physical performance including stage combat, period-accurate movement, and contemporary physical theater.",
  tier: "PHYSICAL"
}, {
  number: "06",
  title: "DIALECT & CHARACTER WORK",
  description: "Bespoke character development and dialect coaching for specific regional requirements and historical accuracy.",
  tier: "TECHNICAL"
}];
export default function TheaterCredits() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const ledger = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="5199" id="theater-credits" className="bg-background text-foreground pt-40 md:pt-60 pb-24 md:pb-40 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1600px] mx-auto">
        {}
        <div ref={header.ref} className={`mb-12 md:mb-16 transition-all duration-700 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-20 md:mb-28">
          <div className="lg:col-span-8">
            <h1 className={`font-default font-light uppercase leading-[1.0] tracking-tighter text-foreground transition-all duration-1000 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            fontSize: "clamp(3rem, 8vw, 6.5rem)"
          }}>
              <span className="inline-block text-transparent" style={{
              WebkitTextStroke: "1px var(--foreground)"
            }}>
                P
              </span>
              ERFORMANCE
              <br />
              CREDITS
              <br />
              INDEX.
            </h1>
          </div>

          <div className="lg:col-span-4 flex lg:items-end">
            <p className={`font-default italic text-muted-foreground text-lg md:text-xl leading-relaxed max-w-[380px] transition-all duration-1000 delay-200 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Acting is the art of controlled vulnerability — a precise
              calibration of breath, silence, and movement designed to hold
              the mirror up to nature.
            </p>
          </div>
        </div>

        {}
        <div ref={ledger.ref} className="border-t border-border">
          {services.map((service, i) => <div data-index={i} key={service.number} className={`group relative grid grid-cols-12 gap-4 md:gap-6 items-start md:items-center py-8 md:py-0 md:h-[120px] border-b border-border px-2 md:px-4 transition-all duration-700 hover:bg-card/40 cursor-pointer ${ledger.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: ledger.isVisible ? `${i * 80}ms` : "0ms"
        }}>
              {}
              <div className="col-span-2 md:col-span-1">
                <span className="font-mono text-xs md:text-sm text-muted-foreground tracking-wider">
                  {service.number}
                </span>
              </div>

              {}
              <div className="col-span-10 md:col-span-5 transition-transform duration-500 group-hover:translate-x-2">
                <h3 className="font-sans font-medium uppercase text-foreground text-xl md:text-3xl lg:text-[32px] leading-tight tracking-tight">
                  {service.title}
                </h3>
              </div>

              {}
              <div className="col-span-12 md:col-span-4 col-start-3 md:col-start-auto">
                <p className="font-sans font-light text-sm md:text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>

              {}
              <div className="col-span-12 md:col-span-2 col-start-3 md:col-start-auto flex items-center justify-start md:justify-end gap-3">
                <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-primary">
                  {service.tier}
                </span>
                <ArrowRight className="size-4 text-primary transition-all duration-500 group-hover:translate-x-2 group-hover:scale-110" aria-hidden="true" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}